<div class="flex flex-row flex-wrap align-items-center gap-3 px-2">
  <p-button
    (click)="changeTheme()"
    styleClass="p-button-small p-button-rounded p-button-sm"
    [icon]="activeTheme === lightTheme ? 'fas fa-moon' : 'fas fa-sun'" />
</div>
